module.exports = __webpack_public_path__ + "img/1-14.405f5bd7.png";